export enum GuidanceStepFeatureFlagFilePrefix {
  CAN_ACCESS_NEW_STEP = 'can_access_new_step'
}
